export default "__VITE_ASSET__eySrqNx2__"